import { useRef } from 'react';
import MojitoPresentation from 'mojito/presentation';
import MojitoCore from 'mojito/core';
import { isEmpty } from 'mojito/utils';
import BonusIndicator from 'modules/bonus-indicator/index.js';

const { FlexPane } = MojitoPresentation.Components;
const classUtils = MojitoCore.Base.classUtils;

const BetBonusPromotions = props => {
    const { bonuses, isActive, mojitoTools, currencyCode } = props;
    const { config } = mojitoTools;
    const bonusesCache = useRef();
    if (isActive) {
        // We will store bonuses in ref to avoid blinking during bonus validations on server.
        bonusesCache.current = bonuses;
    }
    const betBonuses = bonusesCache.current || bonuses;

    if (isEmpty(betBonuses)) {
        return null;
    }

    return (
        <FlexPane
            config={config.container}
            class={classUtils.classNames(`ta-BetBonusPromotions`, props.class)}
        >
            {[...betBonuses]
                .sort((a, b) => a.type.localeCompare(b.type))
                .map(bonus => {
                    return (
                        <BonusIndicator
                            key={`${bonus.type} ${bonus.rate}`}
                            config={config.bonusIndicator}
                            class={`ta-${bonus.type}`}
                            bonusType={bonus.type}
                            bonusInfo={bonus}
                            disabled={!isActive}
                            currencyCode={currencyCode}
                        />
                    );
                })}
        </FlexPane>
    );
};

export default BetBonusPromotions;
